import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Form, Row, Col, Table, Dropdown } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faBolt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import dlt from '../../../assets/images/dlt.png';
import { SHIPMENTSAVEINVOICECATEGORY, SHIPMENTINVOICECATEGORIESSELECT, ADDRESSBOOKDROPDOWN } from '../../../Utils/conts.js';
import { withRFSToken } from '../../../Services/axios';
import { toast } from 'react-toastify';
import Trash from "../../../assets/images/trash.png";
import Edit from "../../../assets/images/edit.png";
import Select from 'react-select';
import { GETDESTINATION } from '../../../Utils/conts.js';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const currencyOptions = [

    { value: "EUR", label: "EUR (€) - Euro" },
    { value: "USD", label: "USD ($) - US Dollar" },
    { value: "PHP", label: "PHP (₱) - Philippine Peso" },
    { value: "JPY", label: "JPY (¥) - Japanese Yen" },
    { value: "GBP", label: "GBP (£) - British Pound" },
    { value: "AUD", label: "AUD (A$) - Australian Dollar" },
    { value: "CHF", label: "CHF (Fr.) - Swiss Franc" },
    { value: "CAD", label: "CAD (C$) - Canadian Dollar" },
    { value: "MXN", label: "MXN ($) - Mexican Peso" },
    { value: "CNY", label: "CNY (¥) - Chinese Yuan" },
    { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar" },
    { value: "SEK", label: "SEK (kr) - Swedish Krona" },
    { value: "RUB", label: "RUB (₽) - Russian Ruble" },
    { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar" },
    { value: "NOK", label: "NOK (kr) - Norwegian Krone" },
    { value: "SGD", label: "SGD (S$) - Singapore Dollar" },
    { value: "TRY", label: "TRY (₺) - Turkish Lira" },
    { value: "KRW", label: "KRW (₩) - South Korean Won" },
    { value: "ZAR", label: "ZAR (R) - South African Rand" },
    { value: "BRL", label: "BRL (R$) - Brazilian Real" },
    { value: "INR", label: "INR (₹) - Indian Rupee" },
    { value: "SAR", label: "SAR (﷼) - Saudi Riyal" },
    { value: "DKK", label: "DKK (kr) - Danish Krone" },
    { value: "RON", label: "RON (lei) - Romanian Leu" },
    { value: "XAF", label: "XAF (Fr) - Central African CFA Franc" },
    { value: "XOF", label: "XOF (Fr) - West African CFA Franc" },
    { value: "DOP", label: "DOP (RD$) - Dominican Peso" },
    { value: "HTG", label: "HTG (G) - Haitian Gourde" },
    { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar" },
    { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar" },
    { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar" },
    { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder" },
    { value: "COP", label: "COP (COL$) - Colombian Peso" },
    { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights" },
    { value: "XBT", label: "XBT (₿) - Bitcoin" },
    { value: "WGH", label: "WGH - West German Hard Currency" }
];

const vatRates = [
    { value: '', label: 'Select VAT Rate', percent: 0 },
    { value: '0', label: '0% - Exempt', percent: 0 },
    { value: '5', label: '5% - Reduced Rate', percent: 5 },
    { value: '12', label: '12% - Standard Rate', percent: 12 },
    { value: '18', label: '18% - Standard Rate', percent: 18 },
    { value: '20', label: '20% - General Rate', percent: 20 },
    { value: '21', label: '21% - General Rate', percent: 21 },
];

const defaultRow = {
    no: 1,
    category: '',
    costs: '',
    ttl: '',
    vat: '20',
    vatAmount: 0,
};

const CustomerSettings = ({ isModal,  onSelect = () => {}, showAddCustomer = true }) => {
    // Set EUR as default currency and 20% VAT as default
    const [customerModal, setCustomerModal] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState('eur');
    const [vatType, setVatType] = useState('exclude'); // 'exclude' or 'include'
    const [rows, setRows] = useState([{ ...defaultRow }]);
    const gridRefs = useRef(null);
    const [allData, setAlldata] = useState(null);
    const [addressBookList, setAddressBookList] = useState(null);

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);
    const gridRef = useRef(null);
    const [gridData, setGridData] = useState([]);
    const [gridSelect, setGridSelect] = useState([]);

    useEffect(() => {
        if (isMounted.current) return;
        addressBookDropdown();
        setIsLoading(false);

        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);

    // Get currency symbol
    const getCurrencySymbol = () => {
        const found = currencyOptions.find(opt => opt.value === selectedCurrency);
        return found ? found.symbol : '';
    };

    // Calculate VAT Amount for a row
    const calculateVatAmount = (costs, vatValue) => {
        const vatObj = vatRates.find(v => v.value === vatValue);
        const percent = vatObj ? vatObj.percent : 0;
        const costNum = parseFloat(costs) || 0;
        return ((costNum * percent) / 100).toFixed(2);
    };

    const addressBookDropdown = async () => {
        try {
            const res = await withRFSToken.get(ADDRESSBOOKDROPDOWN)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setAddressBookList(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Calculate Subtotal, VAT Total, and Grand Total
    const getSubtotal = () => rows.reduce((sum, row) => sum + (parseFloat(row.costs) || 0), 0);
    const getVatTotal = () => rows.reduce((sum, row) => sum + (parseFloat(row.vatAmount) || 0), 0);
    const getGrandTotal = () => {
        if (vatType === 'exclude') {
            return getSubtotal() + getVatTotal();
        } else {
            return getSubtotal();
        }
    };

    // Handle input change for a row
    const handleRowChange = (idx, field, value) => {
        const updatedRows = rows.map((row, i) => {
            if (i === idx) {
                let updatedRow = { ...row, [field]: value };
                // Recalculate VAT Amount if costs or vat changes
                if (field === 'costs' || field === 'vat') {
                    updatedRow.vatAmount = calculateVatAmount(
                        field === 'costs' ? value : row.costs,
                        field === 'vat' ? value : row.vat
                    );
                }
                return updatedRow;
            }
            return row;
        });
        setRows(updatedRows);
    };

    // Add a new row
    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                ...defaultRow,
                no: rows.length + 1,
            },
        ]);
    };

    // Delete a row
    const handleDeleteRow = (idx) => {
        if (rows.length === 1) return;
        const updatedRows = rows.filter((_, i) => i !== idx).map((row, i) => ({ ...row, no: i + 1 }));
        setRows(updatedRows);
    };

    // On currency change, update state and force re-render for symbol
    const handleCurrencyChange = (e) => {
        setSelectedCurrency(e.target.value);
    };

    const applyDefaultActiveFilter = () => {
        const filterGroup = new window.$.jqx.filter();
        const filter = filterGroup.createfilter('stringfilter', 'Active', 'equal');
        filterGroup.addfilter(1, filter);
        window.$(gridRef.current).jqxGrid('addfilter', 'activity_status', filterGroup);
        window.$(gridRef.current).jqxGrid('applyfilters');
    };
    
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const source = {
                datatype: 'json',
                // root: 'response_data',
                cache: false,
                datafields: [
                    { name: 'customer_type', type: 'string' },
                    { name: 'activity_status', type: 'string' },
                    { name: 'awb_shp_status', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'id', type: 'number' },
                    { name: 'expire_days', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'org_id', type: 'number' },
                    { name: 'agent_code', type: 'string' },
                    { name: 'pgts', type: 'string' },
                    { name: 'user_id', type: 'number' },
                    { name: 'account_number', type: 'string' },
                    { name: 'street_name', type: 'string' },
                    { name: 'country', type: 'string' },
                    { name: 'city', type: 'string' },
                    { name: 'postal_code', type: 'string' },
                    { name: 'vat_nr', type: 'string' },
                ],
                url: `${process.env.REACT_APP_RFS_URL}address-book/list`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                // localdata: gridData[activeTab],
                pagesize: !isModal ? 50 : 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRef.current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRef.current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + Edit + '" class="row_edit" /></div>';
                    },
                    width: '6%', filterable: false,
                },
                { text: 'Customer Name', datafield: 'name', width: '12%', filtertype:'input' },
                {
                  text: 'Status', datafield: 'activity_status', width: '8%', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Active', value: 'Active' },
                        { label: 'Inactive', value: 'Inactive' },
                    ],
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        const isActive = cellValue == '1' ;
                        const status = isActive ? 'Active' : 'Inactive';
                        const colorClass = isActive ? 'text-success' : 'text-danger';
                        return `<div class="jqx-grid-cell-left-align ${colorClass}" style="margin-top: 12px; margin-left:5px">${status}</div>`;
                    }
                },
                {
                    text: 'Customer Type', datafield: 'customer_type', width: '8%', filtertype: 'checkedlist', filterable: true,
                    filteritems: [
                        { label: 'Forwarder', value: 'forwarder' },
                        { label: 'Shipper', value: 'Shipper' },
                        { label: 'Consignee', value: 'Consignee' },
                    ],
                },
                { text: 'Agent Code', datafield: 'agent_code', width: '10%',filtertype:'input' },
                { text: 'PGTS Code', datafield: 'pgts', width: '9%',filtertype:'input' },
                { text: 'Inv Due Days', datafield: 'expire_days', width: '8%',filtertype:'input' },
                { text: 'Email', datafield: 'email', width: '20%',filtertype:'input' },
                { text: 'Account Number', datafield: 'account_number', width: '12%',filtertype:'input' },
                { text: 'Vat Nr', datafield: 'vat_nr', width: '10%',filtertype:'input' },
                // { text: 'Mobile', datafield: 'number', width: '10%' },
                // { text: 'Airport Origin', datafield: 'airport_code', width: '10%' },
                // {
                //     text: 'Address', datafield: 'address', width: '20%', filtertype:'input', cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
                //         const addressParts = [rowdata.street_name, rowdata.postal_code, rowdata.city, rowdata.country].filter(part => part && part.trim() !== '');
                //         const address = addressParts.join(', ');
                //         return `<div class="jqx-grid-cell-left-align" style="margin-top: 13px;">${address}</div>`;
                //     }
                // }

            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: !isModal ? 1040 : 600,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: !isModal ? ['50', '100', '200', '500'] : ['50', '100'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                ready: function () {
                    if(isModal)
                    applyDefaultActiveFilter();
                },
                // rendered: function () {
                //   const rows = window.$(gridRef.current).jqxGrid('getrows');
                //   (checkUlds).forEach(uldNumber => {
                //     rows.forEach((element, index) => {
                //       if (element.uld_number == uldNumber) {
                //         window.$(gridRef.current).jqxGrid('selectrow', index);
                //       }
                //     });
                //   });
                // }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                fetchCustomer(rowData?.id);
            });
            // window.$(gridRef.current).on('click', '.screen', function () {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
            //     setIsModal(true)
            // });
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }

                    setGridSelect(prevGridSelect => {
                        const updated = prevGridSelect.some(r => r.id === selectedRow.id)
                            ? prevGridSelect
                            : [...prevGridSelect, selectedRow];

                        onSelect(updated);
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                        onSelect(allIds);
                    } else {
                        setGridSelect([]);
                        onSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => {
                        // prevSelection.filter(row => row.id !== unselectedRowId)
                        const updated = prevSelection.filter(row => row.id !== unselectedRowId);
                        onSelect(updated);
                        return updated;
                    });
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            // window.$(gridRef.current).off('cellclick');
            // window.$(gridRef.current).on('cellclick', (event) => {
            //     const args = event.args.row.bounddata;
            //     if (![4, 10].includes(event.args.columnindex)) {
            //         if (gridSelect) {
            //             gridSelect.forEach(item => {
            //                 const selectedRowBoundIndex = item.boundindex;
            //                 window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            //             });
            //         }
            //         // loadDetails(args.uld_number);
            //         setSelectedRowData(args)
            //         setTimeout(() => {
            //             window.$(gridRef.current).jqxGrid('refresh');
            //         }, 30);
            //     }
            // });
            // }
        }
    }, [gridData]);

    // const options = [];
    const [getDestination, setGetDestination] = useState([]);
    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.station_id,
                        label: item.port_code,
                        // address: item.address,
                        // station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchCustomer = async (id) => {
        try {
            const res = await withRFSToken.post("address-book/details", { id: id, })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? {
                        ...innerData,
                        number: innerData.mobile ?? '',
                        airport_origin: innerData.airport_code ?? '',
                    }: {};
                    setCustomerData(prev => ({
                        ...prev,
                        ...transformedData,
                        id: id,
                    }));
                    setCustomerModal(true);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchDestination();
    }, []);
    const [customerData, setCustomerData] = useState({ agent_or_customer: 'C' })
    const [validationErrors, setValidationErrors] = useState({})
    const CustomerOptions = [
        // { label: '--', value: '' },
        // { label: 'Airline', value: 'A' },
        { label: 'Forwarder', value: 'F' },
        // { label: 'Handler', value: 'H' },
        { label: 'Shipper', value: 'S' },
        { label: 'Consignee', value: 'C' },
        // { label: 'Trucker', value: 'T' }
    ];
    const CustomerOrAgent = [
        // { label: '--', value: '' },
        { label: 'Customer', value: 'C' },
        { label: 'Agent', value: 'A' },
    ];
    const handleCustomerChange = (name, value) => {
        setCustomerData(prevData => ({
            ...prevData,
            [name]: value
        }));

        // Clear validation error for this field when user starts typing
        if (validationErrors[name]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const handleCustomerAddressChange = (field, value, index = 0) => {
        setCustomerData(prevData => {
            const currentAddressArray = Array.isArray(prevData.address) && prevData.address.length > 0
                ? prevData.address
                : [{ street_name: '', postal_code: '', city: '', country: '' }];
            const updatedAddressArray = currentAddressArray.map((addr, i) => (
                i === index ? { ...addr, [field]: value } : addr
            ));
            return { ...prevData, address: updatedAddressArray };
        });
    };
    const hideCustomerModal = () => {
        setCustomerModal(false);
        setCustomerData({ agent_or_customer: 'C' })
    };

    const validateCustomerData = () => {
        const errors = {};

        // Validate Customer Name
        if (!customerData.name || customerData.name.trim() === '') {
            errors.name = 'Customer Name is required';
        }

        // Validate Customer/Agent (only if not in modal)
        if (!isModal && (!customerData.agent_or_customer || customerData.agent_or_customer === '')) {
            errors.agent_or_customer = 'Customer/Agent selection is required';
        }

        // Validate Customer Type
        if (!customerData.customer_type || customerData.customer_type === '') {
            errors.customer_type = 'Customer Type is required';
        }

        // Validate Agent Code
        if (!customerData.agent_code || customerData.agent_code.trim() === '') {
            errors.agent_code = 'Agent Code is required';
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleCustomerSave = async () => {
        // Clear previous validation errors
        setValidationErrors({});

        // Validate required fields
        if (!validateCustomerData()) {
            toast.error('Please fill in all required fields');
            return;
        }

        try {
            const res = await withRFSToken.post('address-book/add-update', customerData)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code != 200) {
                        toast.error(res.data.response_msg)
                        return;
                    }
                    toast.success(res.data.response_msg);
                    setTimeout(() => {
                        setIsLoading(false);
                        window.$(gridRef.current).jqxGrid('updatebounddata')
                    }, 1);

                    gridSelect.forEach(item => {
                        const selectedRowBoundIndex = item.boundindex;
                        window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                    });
                    setCustomerModal(false);
                    setCustomerData({ agent_or_customer: 'C' })
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleShow = () => {
        setCustomerModal(true);
        setCustomerData({ agent_or_customer: 'C' })
    }

    const SBack = localStorage.getItem('SettingsBack');

    const handleActiveInvoice = async (status) => {
            let filterStatus;
            let payload = {}
            if (status == 1) {
                const alreadyActive = gridSelect.filter(i => i.awb_shp_status == 1);
                if (alreadyActive.length === gridSelect.length) {
                    toast.success("Selected customer are already active.");
                    return;
                }
                filterStatus = gridSelect.map(d => d.id);
                payload = { awb_shp_id: filterStatus }
            } else if (status == 0) {
                const alreadyInactive = gridSelect.filter(i => i.awb_shp_status == 0);
                if (alreadyInactive.length === gridSelect.length) {
                    toast.error("Selected customer are already inactive.");
                    return;
                }
                filterStatus = gridSelect.map(d => d.id)
                payload = { awb_shp_id: filterStatus }
            }
            // if (filterStatus.length === 0) {
            //     toast.error("Please select at least one customer to change status.");
            //     return;
            // }
            try {
                const res = await withRFSToken.post('address-book/delete-restore', payload)
                    .then(function (res) {
                        if (res.data.response_code == 200) {
                            toast.success(res.data.response_msg);
                            setTimeout(() => {
                                setIsLoading(false);
                                window.$(gridRef.current).jqxGrid('updatebounddata')
                            }, 1);

                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                            });
                            setGridSelect([]);
                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRefs.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                            });
                        }
                    });
    
            } catch (error) {
                console.error('Error sending request:', error);
            }
        };

    return (
        <>
            {/* {console.log('gridSelect', gridSelect)} */}
            {!isModal ?
                <>
                    {/* <div className=""> */}
                        {/* <Header page_type='fsm' logo_url='/ForwarderShipments/Export' /> */}
                        {/* <Header
                            page_type='fsm'
                            logo_url={SBack ? SBack : '/ForwarderShipments/Export'}
                            sBackUrl={SBack ? SBack : '/ForwarderShipments/Export'}
                        />
                        <div className="main-panel">
                            <div className="row">
                                <LeftSettings /> */}
                                <div className='col-9 col-xxl-9 stting_right'>
                                    <div className='settingbg_right'>
                                        <div className='category_invoice_title'>
                                            <h4>Add/Edit Customer</h4>
                                            <p>Set your notification preferences for when you are in or away from the dashboard</p>
                                        </div>
                                        <div className='d-flex justify-content-start mb-3'>
                                            <Button variant="primary me-2" onClick={handleShow}><span className='me-2'><FontAwesomeIcon icon={faPlus} /></span>Add Customer</Button>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                                    <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleActiveInvoice('1')}>Active Customer</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleActiveInvoice('0')}>Inactive Customer</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div className='trashdonload'>
                                            {!isLoading && <div ref={gridRef} className='setting_bookinggrid' ></div>}
                                        </div>
                                    </div>
                                </div>
                            {/* </div>
                        </div>
                    </div> */}
                </>
                :
                <>
                    {showAddCustomer && <span className='text-end mt-2 fwr_customer_add'><Button variant="primary" onClick={handleShow} >+ Add Customer</Button></span>}
                    <div className='trashdonload add_category_modal_bdy_content mt-0'>
                        {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                    </div>
                </>
            }
            <Modal show={customerModal} centered onHide={hideCustomerModal} className='addfrom' >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Add Customer
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Customer Name <span>*</span></Form.Label>
                            <Form.Control type="text" name='name' placeholder="Add Name" value={customerData.name} onChange={(e) => handleCustomerChange('name', e.target.value)} />
                        </Col>
                    </Form.Group>
                    {!isModal &&
                        <Form.Group as={Row} className='mb-2'>
                            <Col sm="12">
                                <Form.Label>Customer/Agent <span>*</span></Form.Label>
                                <Select
                                    options={CustomerOrAgent}
                                    onChange={(selected) => {
                                        handleCustomerChange('agent_or_customer', selected ? selected.value : '');
                                    }}
                                    placeholder="Customer"
                                    className='rfs_autoslct'
                                    name="agent_or_customer"
                                    value={CustomerOrAgent.find(option => option.value === customerData.agent_or_customer) || null}
                                />
                            </Col>
                        </Form.Group>
                    }
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Customer Type <span>*</span></Form.Label>
                            <Select
                                options={CustomerOptions}
                                onChange={(selected) => {
                                    handleCustomerChange('customer_type', selected ? selected.value : '');
                                }}
                                placeholder="Customer"
                                className='rfs_autoslct'
                                name="customer_type"
                                value={CustomerOptions.find(option => option.value === customerData.customer_type) || null}
                            />
                        </Col>
                    </Form.Group>
                     <Form.Group as={Row} className='mb-2'>
                        <Col sm="6">
                            <Form.Label>PGTS Code</Form.Label>
                            <Form.Control type="text" name='number' placeholder="Add PGTS Code" value={customerData.pgts} onChange={(e) => handleCustomerChange('pgts', e.target.value)} />
                        </Col>
                        <Col sm="6">
                            <Form.Label>Invoice Due Days</Form.Label>
                            <Form.Control type="number" min={0} max={999} name='expire_days' placeholder="Add Due Days" value={customerData.expire_days} onChange={(e) => handleCustomerChange('expire_days', e.target.value)} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="6">
                            <Form.Label>Agent Code <span>*</span></Form.Label>
                            <Form.Control type="text" name='agent_code' placeholder="Add Agent Code" value={customerData.agent_code} onChange={(e) => handleCustomerChange('agent_code', e.target.value)} />
                        </Col>
                        <Col sm="6">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="text" name='email' placeholder="Add Email" value={customerData.email} onChange={(e) => handleCustomerChange('email', e.target.value)} />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="6">
                            <Form.Label>Account Number</Form.Label>
                            <Form.Control type="text" name='number' placeholder="Add Account no." value={customerData.account_number} onChange={(e) => handleCustomerChange('account_number', e.target.value)} />
                        </Col>
                        <Col sm="6">
                            <Form.Label>Vat Nr</Form.Label>
                            <Form.Control type="text" name='vat_nr' placeholder="Vat Number" value={customerData.vat_nr} onChange={(e) => handleCustomerChange('vat_nr', e.target.value)} />
                        </Col>
                    </Form.Group>
                    {/* <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                                type="text"
                                name='address'
                                placeholder="Add Address"
                                value={customerData.address}
                                onChange={(e) => handleCustomerChange('address', e.target.value)}
                            />
                        </Col>
                    </Form.Group> */}
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Street Name</Form.Label>
                            <Form.Control
                                type="text"
                                name='street_name'
                                placeholder="Add Street Name"
                                value={customerData.street_name}
                                onChange={(e) => handleCustomerChange('street_name', e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="6">
                            <Form.Label>Postal Code</Form.Label>
                            <Form.Control
                                type="text"
                                name='postal_code'
                                placeholder="Add Postal Code"
                                value={customerData.postal_code}
                                onChange={(e) => handleCustomerChange('postal_code', e.target.value)}
                            />
                        </Col>
                        <Col sm="6">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                type="text"
                                name='city'
                                placeholder="Add City"
                                value={customerData.city}
                                onChange={(e) => handleCustomerChange('city', e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className='mb-2'>
                        <Col sm="12">
                            <Form.Label>Country</Form.Label>
                            <Form.Control
                                type="text"
                                name='country'
                                placeholder="Add Country"
                                value={customerData.country}
                                onChange={(e) => handleCustomerChange('country', e.target.value)}
                            />
                        </Col>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={hideCustomerModal}>
                            Discard
                        </Button>
                        <Button variant="primary" onClick={handleCustomerSave}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default CustomerSettings;